module.exports = "/images/cs.svg";